/* eslint-disable */
export default {
  header: 'Turn off error tracking',
  content:
    'Turning off error tracking mode will delete any current error logs. Do you wish to continue?',
  confirm: 'Turn off',
  cancel: 'Cancel',
} as const;

// @key: @#@"header"@#@ @source: @#@"Turn off error tracking"@#@
// @key: @#@"content"@#@ @source: @#@"Turning off error tracking mode will delete any current error logs. Do you wish to continue?"@#@
// @key: @#@"confirm"@#@ @source: @#@"Turn off"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
